<template>
  <div>
    <RouterView />
    <div class="modal-target" />
  </div>
</template>

<script lang="ts" setup>
  import '@/styles/main.scss';
  import { captureException, reportMFRendered } from '@experience/core-hostapp-share-lib';
  import { initHotReloader } from '@experience/vite-plugin-wc-extract-styles';
  import { onErrorCaptured, onMounted, useShadowRoot, nextTick, provide } from 'vue';
  import { useRouter } from 'vue-router';
  import { MF_NAME } from './const';

  const router = useRouter();

  onErrorCaptured((err) => captureException(err, { mf: MF_NAME }));

  onMounted(async () => {
    // Make sure router is fully initialized
    await router.isReady();
    // Wait for the current render to complete
    await nextTick();

    // Delay the call to ensure DOM is fully updated
    setTimeout(() => {
      reportMFRendered(MF_NAME);
    }, 0);
  });

  const shadowRoot = useShadowRoot();

  provide('shadowRoot', shadowRoot);

  initHotReloader(import.meta.hot, shadowRoot);
</script>

<style lang="scss">
  :root {
    background-color: #242424;
    color: rgba(255, 255, 255, 0.87);
    font-weight: 400;
    font-family: var(--global-typography-family-base);
    line-height: 1.5;
    color-scheme: light dark;
    font-synthesis: none;
    text-rendering: optimizelegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    color: #646cff;
    font-weight: 500;
    text-decoration: inherit;
  }

  a:hover {
    color: #535bf2;
  }

  body {
    display: flex;
    place-items: center;
    min-width: 320px;
    min-height: 100vh;
    margin: 0;
  }

  h1 {
    font-size: 3.2em;
    line-height: 1.1;
  }

  button {
    padding: 0.6em 1.2em;
    border: 1px solid transparent;
    border-radius: 8px;
    background-color: #1a1a1a;
    font-weight: 500;
    font-size: 1em;
    font-family: inherit;
    cursor: pointer;
    transition: border-color 0.25s;
  }

  button:hover {
    border-color: #646cff;
  }

  button:focus,
  button:focus-visible {
    outline: 4px auto -webkit-focus-ring-color;
  }

  .card {
    padding: 2em;
  }
</style>
